import { Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'kh-image-viewe-modal',
  templateUrl: './image-viewer-modal.component.html',
  styleUrls: ['./image-viewer-modal.component.less'],
  standalone: false
})
export class ImageViewerModalComponent {
  private readonly bsModalRef = inject(BsModalRef);

  public imageUrl = '';

  public closeModal(): void {
    this.bsModalRef.hide();
  }
}
